import { useEffect, useState } from "react";
import "./cart.css";

function Cart() {
  const [cart, setCart] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [cartLoading, setCartLoading] = useState(true);
const [userLoading, setUserLoading] = useState(true);
  const [user, setUser] = useState({
    name: "",
    mobile: "",
    address: ""
  });

   const fetchCart = async () => {
    const token = localStorage.getItem("token");
    setCartLoading(true);
  try {
    const res = await fetch("https://citrine-backend-0hws.onrender.com/api/cart", {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    setCart(data);
     } finally {
    setCartLoading(false);
  }
  };

   const fetchUser = async () => {
    const token = localStorage.getItem("token");
    setUserLoading(true);
  try {
    const res = await fetch("https://citrine-backend-0hws.onrender.com/api/user", {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    setUser({
      name: data.name || "",
      mobile: data.mobile || "",
      address: data.address || "",
    });
    } finally {
    setUserLoading(false);
  }
  };

  useEffect(() => {
    fetchCart();
    fetchUser();
  }, []);

  const updateQty = async (id, qty) => {
    if (qty < 1) return; // prevent negative

    const token = localStorage.getItem("token");

    await fetch(`https://citrine-backend-0hws.onrender.com/api/cart/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ quantity: qty })
    });
window.dispatchEvent(new Event("cartUpdated"));
    fetchCart();
  };

  const removeItem = async (id) => {
    const token = localStorage.getItem("token");

    await fetch(`https://citrine-backend-0hws.onrender.com/api/cart/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` }
    });
window.dispatchEvent(new Event("cartUpdated"));
    fetchCart();
  };

  const total = cart.reduce(
    (sum, item) => sum + item.product_price * item.quantity,
    0
  );

  const handleUserChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const saveUserInfo = async () => {
    const token = localStorage.getItem("token");
    await fetch("https://citrine-backend-0hws.onrender.com/api/user", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
       Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(user)
    });
  };

const handleProceedToPay = async () => {
  await saveUserInfo(); // save delivery details first

  const token = localStorage.getItem("token");

  // Create payment order
  const res = await fetch("https://citrine-backend-0hws.onrender.com/api/payment/order", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ amount: total * 1 }) // convert to paise
  });

  const { paymentData, signature } = await res.json();

  // Redirect to PhonePe page (example)
  // In real integration, you need to open PhonePe SDK or deep link
  window.open(
    `https://merchant.phonepe.com/pg/v1/pay?merchantId=${paymentData.merchantId}&merchantOrderId=${paymentData.merchantOrderId}&amount=${paymentData.amount}&currency=INR&customerId=${paymentData.customerId}&redirectUrl=${encodeURIComponent(paymentData.redirectUrl)}&signature=${signature}`,
    "_blank"
  );
};


  return (



  <div className="cart-container">
    {(cartLoading || userLoading) ? (
      <div id="loader">
    <div className="loader-container">
      <div className="loader"></div>
      <p>Loading...</p>
    </div>
  </div>
    ) : (
      <>
        <h2 className="cart-title">🛒 Your Cart</h2>

        {cart.length === 0 ? (
          <div className="empty-cart">Your cart is empty</div>
        ) : (
          <>
            <div className="cart-grid">
              {cart.map((item) => (
                <div key={item.cart_id} className="cart-card">
                  {/* Product Info */}
                  <div className="cart-info">
                    <h4>{item.product_name}</h4>
                    <p>₹ {item.product_price}</p>
                  </div>

                  {/* Quantity */}
                  <div className="cart-qty">
                    <button onClick={() => updateQty(item.cart_id, item.quantity - 1)}>-</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQty(item.cart_id, item.quantity + 1)}>+</button>
                  </div>

                  {/* Remove */}
                  <button className="remove-btn" onClick={() => removeItem(item.cart_id)}>
                    Remove
                  </button>
                </div>
              ))}

              <button className="checkout-btn" onClick={() => setShowModal(true)}>
                Checkout
              </button>
            </div>

            {/* Total */}
            <div className="cart-total">Total: ₹ {total}</div>
          </>
        )}

        {/* Modal for Checkout */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal">
              <h3>Order Summary</h3>
              <div className="modal-cart-items">
                {cart.map((item) => (
                  <div key={item.cart_id} className="modal-cart-item">
                    <span>{item.product_name} x {item.quantity}</span>
                    <span>₹ {item.product_price * item.quantity}</span>
                  </div>
                ))}
              </div>

              <h4>Grand Total: ₹ {total}</h4>

              <h3>Delivery Details</h3>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={user.name}
                onChange={handleUserChange}
              />
              <input
                type="text"
                name="mobile"
                placeholder="Mobile Number"
                value={user.mobile}
                onChange={handleUserChange}
              />
              <textarea
                name="address"
                placeholder="Address"
                value={user.address}
                onChange={handleUserChange}
              />

              <div className="modal-buttons">
                <button className="closemodel" onClick={() => setShowModal(false)}>Cancel</button>
                <button className="proceedtopay" onClick={handleProceedToPay}>Proceed to Pay</button>
              </div>
            </div>
          </div>
        )}
      </>
    )}
  </div>












































































    
//     <div className="cart-container">
//       {(cartLoading || userLoading) ? (
//   <div style={styles.loaderContainer}>
//     <div className="loader"></div>
//     <p>Loading products...</p>
//   </div>
// ) : (
//       <h2 className="cart-title">🛒 Your Cart</h2>

//       {cart.length === 0 ? (
//         <div className="empty-cart">Your cart is empty</div>
//       ) : (
//         <>
//           <div className="cart-grid">
//             {cart.map((item) => (
//               <div key={item.cart_id} className="cart-card">
                
//                 {/* Product Info */}
//                 <div className="cart-info">
//                   <h4>{item.product_name}</h4>
//                   <p>₹ {item.product_price}</p>
//                 </div>

//                 {/* Quantity */}
//                 <div className="cart-qty">
//                   <button onClick={() => updateQty(item.cart_id, item.quantity - 1)}>-</button>
//                   <span>{item.quantity}</span>
//                   <button onClick={() => updateQty(item.cart_id, item.quantity + 1)}>+</button>
//                 </div>

//                 {/* Remove */}
//                 <button
//                   className="remove-btn"
//                   onClick={() => removeItem(item.cart_id)}
//                 >
//                   Remove
//                 </button>

                
//               </div>
              
//             ))}
//              <button
//             className="checkout-btn"
//             onClick={() => setShowModal(true)}
//           >
//             Checkout
//           </button>
//           </div>

//           {/* Total */}
//           <div className="cart-total">
//             Total: ₹ {total}
//           </div>
//         </>
//       )}


//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal">
//             <h3>Order Summary</h3>
//             <div className="modal-cart-items">
//               {cart.map((item) => (
//                 <div key={item.cart_id} className="modal-cart-item">
//                   <span>{item.product_name} x {item.quantity}</span>
//                   <span>₹ {item.product_price * item.quantity}</span>
//                 </div>
//               ))}
//             </div>

//             <h4>Grand Total: ₹ {total}</h4>

//             <h3>Delivery Details</h3>
//           <input
//             type="text"
//             name="name"
//             placeholder="Full Name"
//             value={user.name}
//             onChange={handleUserChange}
//           />
//           <input
//             type="text"
//             name="mobile"
//             placeholder="Mobile Number"
//             value={user.mobile}
//             onChange={handleUserChange}
//           />
//           <textarea
//             name="address"
//             placeholder="Address"
//             value={user.address}
//             onChange={handleUserChange}
//           />

//             <div className="modal-buttons">
//               <button className="closemodel" onClick={() => setShowModal(false)}>Cancel</button>
//               <button className="proceedtopay" onClick={handleProceedToPay}>Proceed to Pay</button>
//             </div>
//           </div>
//         </div>
//       )}
//     )}
//     </div>
  );
}

export default Cart;